(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-grid"] && !window.DesignMode) return;
  try {
    
  $(window).on('load',function(){
    
    var adjustContentBlocksHeight = function() {
      var newHeight = 0;
      $('.image-with-grid-section').each(function(){
		$(this).find('.block.content_container.image_content').each(function(){
          newHeight = $(this).height() > newHeight  ? $(this).height() : newHeight;
        });
		$(this).find('.block.content_container .text_content').each(function(){
		  $(this).height(newHeight);
		});
	  });
    }

    var adjustMainImgHeight = function() {
      var newHeight = 0;
	  $('.feature-row__image-container').each(function(){
		$(this).find('.text_over_image').height( $(this).find('img').height() );
	  });
	}

    adjustContentBlocksHeight();
    adjustMainImgHeight();

	$(window).on('resize',function(){
	  adjustContentBlocksHeight();
	  adjustMainImgHeight();
	});
  });

  } catch(e) { console.error(e); }
})();
})();
